import Module from '../../utils/modules/Module'

export default class ModalModule extends Module {
  constructor(options) {
    super(options)
    this.DOMEl = options.element;
    this.init();
  }

  init() {
    //check if the modal has been closed by the user
    if (localStorage.getItem(this.DOMEl.dataset.radId + 'modalClosed') === null) {
      this.DOMEl.classList.remove('is-hidden');
    } else if (localStorage.getItem(this.DOMEl.dataset.radId + 'modalClosed_expiresIn') !== null ) {
      if( localStorage.getItem(this.DOMEl.dataset.radId + 'modalClosed_expiresIn') < Date.now()){
        localStorage.removeItem(this.DOMEl.dataset.radId + 'modalClosed');
        localStorage.removeItem(this.DOMEl.dataset.radId + 'modalClosed_expiresIn');
        this.DOMEl.classList.remove('is-hidden');
      }
    }

    this.DOMEl.querySelector('.btn-close-popup').addEventListener('click', () => {
      this.close();
    });

    this.DOMEl.querySelector('.overlay').addEventListener('click', () => {
      this.close();
    });
  }

  close() {
    this.DOMEl.classList.add('is-hidden');
    //set a cookie to remember the user has closed the modal in the last 24 hours
    localStorage.setItem(this.DOMEl.dataset.radId + 'modalClosed', 'true');

    var now = Date.now();  //millisecs since epoch time, lets deal only with integer
    var schedule = now + ((24 * 60 * 60) * 1000);
    localStorage.setItem(this.DOMEl.dataset.radId + 'modalClosed_expiresIn', schedule);
    console.log(localStorage.getItem(this.DOMEl.dataset.radId + 'modalClosed'));
  }

}
